var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38182 5.13889C13.388 3.93307 17.7649 5.53139 20.7884 9.93379C21.1635 10.4799 21.3511 10.753 21.4816 11.2848C21.5702 11.6457 21.5702 12.3543 21.4816 12.7152C21.3511 13.247 21.1635 13.52 20.7885 14.0661C20.444 14.5678 20.0819 15.033 19.7048 15.4619M2.74999 2.75L21.25 21.25M9.70751 9.70753C9.23917 10.2707 8.74999 11.2103 8.74999 12C8.74999 13.7949 10.2051 15.25 12 15.25C12.8035 15.25 13.7502 14.8005 14.3174 14.3174L17.5 17.5C12.9194 20.4488 6.89269 19.4243 3.21289 14.0677C2.83713 13.5207 2.64925 13.2472 2.51864 12.7154C2.43002 12.3545 2.42998 11.6457 2.51856 11.2848C2.6491 10.753 2.83667 10.4799 3.21182 9.93363C4.11097 8.62442 5.40681 7.31322 6.5 6.5L9.70751 9.70753Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.beb76abef9c76a0c8da390f1fa162942.svg";
export { ForwardRef as ReactComponent };